export const SET_RESOURCES = 'SET_RESOURCES';
export const SET_ACTIVE_RESOURCE = 'SET_ACTIVE_RESOURCE';
export const SET_RESOURCE_VALIDATION = 'SET_RESOURCE_VALIDATION';
export const SET_RESOURCE_PAGINATION = 'SET_RESOURCE_PAGINATION';
export const DELETE_RESOURCE = 'DELETE_RESOURCE';
export const SET_RESOURCE_LOADING = 'SET_RESOURCE_LOADING';

// initial state
const state = {
    list: [],
    active: {},
    isLoading: false,
    resourcePagination: {},
    resourceValidation: {},
}

// getters
const getters = {
    resources: state => state.list,
    resource: state => state.active,
    resourceIsLoading: state => state.isLoading,
    resourceValidation: state => state.resourceValidation,
    resourcePagination: state => state.resourcePagination
}

// actions
const actions = {
    getAllResources: ({commit, state}, payload) => {
        axios.get(laroute.route('api.resources.index'))
            .then((response) => {
                commit(SET_RESOURCES, {
                    resources: response.data.data
                });

                if(response.data.meta) {
                    commit(SET_RESOURCE_PAGINATION, {
                        resourcePagination: response.data.meta
                    });
                }
            })
    },

    getResource: ({commit, state}, payload) => {
        axios.get(laroute.route('api.resources.show', {resource: payload.id}))
        .then((response) => {
            commit(SET_ACTIVE_RESOURCE, {
                resource: response.data.data
            });
        })
    },

    setActiveResource: ({commit, state}, payload) => {
        commit(SET_ACTIVE_RESOURCE, {
            resource: payload.data
        });
    },

    setResourceIsLoading: ({commit, state}, payload) => {
        commit(SET_RESOURCE_LOADING, {
            isLoading: payload
        });
    },

    setResourceValidation: ({commit, state}, event) => {

        let route = laroute.route('api.resource.validation')

        axios.post(route, event)
            .then((response) => {
                commit(SET_RESOURCE_VALIDATION, {
                    resourceValidation: response.data
                });
            })
    },

    getMoreResources: ({commit, state}, payload) => {

        axios.get(laroute.route('api.resources.index', {page: payload.page}))
            .then((response) => {
                commit(SET_RESOURCES, {
                    resources: response.data.data
                });

                commit(SET_RESOURCE_PAGINATION, {
                    resourcePagination: response.data.meta
                });

            })
    },

    deleteResource: ({commit, state}, id) => {
        commit(DELETE_RESOURCE, {
            id: id
        });
    },
}

// mutations
const mutations = {
    SET_RESOURCES: (state, payload) => {
      state.list = payload.resources
    },

    SET_RESOURCE_PAGINATION: (state, payload) => {
      state.resourcePagination = Object.assign({}, state.resourcePagination, payload.resourcePagination);
    },

    SET_ACTIVE_RESOURCE: (state, payload) => {
      state.active = Object.assign({}, state.active, payload.resource);
    },

    DELETE_RESOURCE: (state, payload) => {
        var index = _.findIndex(state.list, function(r) {
            return r.id == payload.id
        });

        state.list.splice(index, 1)
    },

    SET_RESOURCE_LOADING: (state, payload) => {
      state.isLoading = payload.isLoading
    },

    SET_RESOURCE_VALIDATION: (state, payload) => {
      state.resourceValidation = payload.resourceValidation;
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}
